import { Loader } from "@aws-amplify/ui-react";

import { useContext } from "react";
import { Navigate, useParams } from "react-router-dom";

import { LayoutContext } from "layout/context/LayoutContext";

const ProtectedComponent = ({ component, permission, redirectTo }) => {
  const { me } = useContext(LayoutContext);
  const params = useParams();
  const isAllowed = permission ? me.permissions?.includes(permission) : true;
  Object.entries(params).forEach((value) => {
    redirectTo = redirectTo?.replace(`:${value[0]}`, value[1]);
  });

  if (!me.id) return <Loader />;
  return isAllowed ? component : <Navigate to={redirectTo ?? "/"} />;
};

export default ProtectedComponent;
